import React from 'react';
import { Table } from 'reactstrap';

export const RuDoubtfulModal = {
  title: 'Doubtful Runup Observation',
  body: (
    <div>
      Doubtful values
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">n</th>
            <td>Runup entry was not doubtful</td>
          </tr>
          <tr>
            <th scope="row">y</th>
            <td>Runup entry was doubtful</td>
          </tr>
          <tr>
            <th scope="row">m</th>
            <td>The waves likely had a meteorologic source, and thus were not true tsunami waves</td>
          </tr>
          <tr>
            <th scope="row">a</th>
            <td>The waves likely were generated by atmospheric waves from a volcanic source</td>
          </tr>
        </tbody>
      </Table>
    </div>
  ),
};
